var moduleMap = {
	"./RootReducer": function() {
		return Promise.all([__webpack_require__.e("vendors-node_modules_reselect_es_defaultMemoize_js-node_modules_reduxjs_toolkit_node_modules_-965012"), __webpack_require__.e("vendors-node_modules_reduxjs_toolkit_dist_query_react_rtk-query-react_esm_js-node_modules_bab-3f215a"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_axios_axios"), __webpack_require__.e("webpack_sharing_consume_default_reduxjs_toolkit_reduxjs_toolkit"), __webpack_require__.e("src_reducers_rootReducer_ts-webpack_sharing_consume_default_react-redux_react-redux")]).then(function() { return function() { return (__webpack_require__(36140)); }; });
	},
	"./Sockets": function() {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_socket_io-client_socket_io-client"), __webpack_require__.e("src_lib_sockets_ts")]).then(function() { return function() { return (__webpack_require__(67447)); }; });
	},
	"./Const": function() {
		return __webpack_require__.e("src_const_index_tsx").then(function() { return function() { return (__webpack_require__(25235)); }; });
	},
	"./Types": function() {
		return __webpack_require__.e("src_types_index_ts").then(function() { return function() { return (__webpack_require__(46523)); }; });
	},
	"./Functions": function() {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_axios_axios"), __webpack_require__.e("webpack_sharing_consume_default_moment_moment"), __webpack_require__.e("src_functions_index_ts")]).then(function() { return function() { return (__webpack_require__(57632)); }; });
	},
	"./Store": function() {
		return Promise.all([__webpack_require__.e("vendors-node_modules_reselect_es_defaultMemoize_js-node_modules_reduxjs_toolkit_node_modules_-965012"), __webpack_require__.e("vendors-node_modules_reduxjs_toolkit_dist_query_react_rtk-query-react_esm_js-node_modules_bab-3f215a"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_axios_axios"), __webpack_require__.e("webpack_sharing_consume_default_reduxjs_toolkit_reduxjs_toolkit"), __webpack_require__.e("webpack_sharing_consume_default_react-redux_react-redux-_50000"), __webpack_require__.e("src_store_store_ts")]).then(function() { return function() { return (__webpack_require__(14917)); }; });
	},
	"./Libs": function() {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_socket_io-client_socket_io-client"), __webpack_require__.e("src_lib_index_ts")]).then(function() { return function() { return (__webpack_require__(7891)); }; });
	},
	"./Styles": function() {
		return Promise.all([__webpack_require__.e("src_styles_globals_scss-src_styles_globals_scss"), __webpack_require__.e("src_styles_globals_scss")]).then(function() { return function() { return (__webpack_require__(73756)); }; });
	},
	"./AntdStyles": function() {
		return Promise.all([__webpack_require__.e("src_styles_index_less-_f290"), __webpack_require__.e("src_styles_index_less-_279c")]).then(function() { return function() { return (__webpack_require__(58115)); }; });
	},
	"./Plugins": function() {
		return Promise.all([__webpack_require__.e("vendors-node_modules_moment_moment_js"), __webpack_require__.e("webpack_sharing_consume_default_axios_axios"), __webpack_require__.e("webpack_sharing_consume_default_moment_moment"), __webpack_require__.e("webpack_sharing_consume_default_sentry_react_sentry_react-webpack_sharing_consume_default_sen-68b461"), __webpack_require__.e("src_plugins_index_ts")]).then(function() { return function() { return (__webpack_require__(94245)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});